module.exports = __webpack_public_path__ + "img/loader.a2cc7224.gif";